export default __webpack_public_path__ + "static/media/featSportMb.aa6d6ad3.png";